import * as React from "react";
import { css, keyframes } from "@emotion/react";
import {
  accentColor,
  textColor,
} from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

interface IProps {
  text: string;
  isLoading: boolean;
  textStyleKey?: keyof ITextStyle;
}

export const LabeledIndicator: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> | null => {
  const { text, isLoading, textStyleKey = "default" } = props;
  if (!isLoading) {
    return null;
  }
  return (
    <div css={blockStyle}>
      <div css={loaderStyle}>
        <div css={loaderPieStyle} />
      </div>
      <div css={textStyle[textStyleKey]}>{text}</div>
    </div>
  );
};

export interface ITextStyle {
  default: any;
  redirect: any;
}

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const blockStyle = css`
  display: flex;
  align-items: center;
`;
const loaderStyle = css`
  position: relative;
  height: 1rem;
  width: 1rem;
  margin-right: ${space.atom};
  ${moreThanBreakpoint("desktop")} {
    height: 1.25rem;
    width: 1.25rem;
  }
`;
const loaderPieStyle = css`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  border-top: 0.25rem solid ${accentColor.primaryColor};
  border-right: 0.25rem solid ${accentColor.primaryColor};
  border-bottom: 0.25rem solid ${accentColor.primaryColor};
  border-left: 0.25rem solid #fff;
  animation-name: ${spin};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  ${moreThanBreakpoint("desktop")} {
    width: 0.625rem;
    height: 0.625rem;
    border-width: 0.375rem;
  }
`;

const textStyle: ITextStyle = {
  default: css`
    font-size: ${fontSize.caption};
    color: ${textColor.primaryDarkColor};
    line-height: ${lineHeight.caption2};
    ${moreThanBreakpoint("desktop")} {
      font-size: ${fontSize.body};
      line-height: ${lineHeight.body2};
    }
  `,
  redirect: css`
    font-size: 18px;
    color: ${textColor.primaryDarkColor};
    line-height: 1.5;
  `,
};
